import PropTypes from 'prop-types'
import { Route, Switch, useLocation } from 'react-router-dom'
import { connectStateResults } from 'react-instantsearch-dom'

import {
  Box,
  Columns,
  Col,
  Container,
  LoadingPlane,
} from '@redriverpress/system'
import { SearchBox } from 'Packages/search'
import { usePathnameTracking } from 'Packages/track'

import AllFlashcardsGenre from './components/Genre/AllFlashcardsGenre'
import Genre from './components/Genre/Genre'
import Genres from './components/Genres/Genres'
import Results from './components/FlashcardsSearchResults'
import SelectionManager from './components/SelectionManager/SelectionManager'

import {
  ALL_FLASHCARDS_PATH,
  GENRE_AND_CATEGORY_PATH,
  GENRE_PATH,
} from './constants/routes'
import { useMediaGallery } from '../contexts'

function Flashcards({ searchState }) {
  const [
    {
      userAccess: { userIsLoading, userHasAccess, userLoggedIn },
    },
  ] = useMediaGallery()
  const { search } = useLocation()
  usePathnameTracking()

  return (
    <>
      {/* <Container pt={[4, null, null, 5]} pb={[3, null, null, 4]}>
      </Container> */}
      <Box py={[3, null, null, 4]} bg='gray100'>
        <Container>
          <Box pt={[1, null, null, 2]} pb={[2, null, null, 3]}>
            <SearchBox placeholder='Flashcards' withCancelButton />
          </Box>
          {userIsLoading ? (
            <Box display='flex' justifyContent='center'>
              <LoadingPlane />
            </Box>
          ) : (
            <Columns>
              <Col width={[1, null, 1 / 3]}>
                <Route
                  path={[
                    GENRE_AND_CATEGORY_PATH,
                    GENRE_PATH,
                    ALL_FLASHCARDS_PATH,
                  ]}
                >
                  <Genres />
                </Route>
              </Col>
              <Col width={[1, null, 2 / 3]}>
                {/* Results shown only when search state AND query param are set. */}
                {/* This is to prevent excessive rerenders in between either of these being updated. */}
                {search.includes('query=') && searchState.query ? (
                  <Results userHasAccess={userHasAccess} />
                ) : (
                  <Switch>
                    <Route path={ALL_FLASHCARDS_PATH} exact>
                      <AllFlashcardsGenre userHasAccess={userHasAccess} />
                    </Route>
                    <Route path={[GENRE_AND_CATEGORY_PATH, GENRE_PATH]}>
                      <Genre
                        userHasAccess={userHasAccess}
                        userLoggedIn={userLoggedIn}
                      />
                    </Route>
                  </Switch>
                )}
              </Col>
            </Columns>
          )}
        </Container>
        {userHasAccess && <SelectionManager />}
      </Box>
    </>
  )
}

Flashcards.propTypes = {
  searchState: PropTypes.shape({
    query: PropTypes.string,
  }).isRequired,
}

export default connectStateResults(Flashcards)
